import events from "../../../events/EventsObservable";
import {ACTION_EVENTS} from "../../UserAction";
import {isIphoneSafari} from "../../../device/device";
import * as Hammer from "hammerjs";

export default class FullscreenSwiper {

    private _iosSwiperUnderLay: HTMLElement;
    private _iosSwiperInterLay: HTMLElement;
    private _iosSwiperOverLay: HTMLElement;

    private _type: string;

    constructor(type: string|null) {
        this._type = type;

        let underlay = document.createElement("div");
        underlay.classList.add("mx-swiper-underlay");
        document.body.appendChild(underlay);
        this._iosSwiperUnderLay = underlay;

        let interlay = document.createElement("div");
        interlay.classList.add("mx-swiper-interlay");
        document.body.appendChild(interlay);
        this._iosSwiperInterLay = interlay;

        let hand = document.createElement("div");
        hand.classList.add("mx-swiper-hand");
        if (this._type === "jarda") {
            hand.classList.add("mx-swiper-hand-better");
        }
        interlay.appendChild(hand);

        let overlay = document.createElement("div");
        if (isIphoneSafari()) {
            overlay.classList.add("mx-ios-swiper-overlay");
        } else {
            overlay.classList.add("mx-swiper-overlay");
            let mc = new Hammer(interlay);
            mc.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
            mc.on("swipeup", ev => {
                events.dispatch(ACTION_EVENTS.ACTION_GAME_CANVAS_SWIPE_UP, ev);
            });
        }
        document.body.appendChild(overlay);
        this._iosSwiperOverLay = overlay;
    }

    enable(enable = true) {

        if (!this._iosSwiperUnderLay) {
            return;
        }

        if (enable) {

            // enableBodyScroll(document.getElementById("wrapper"));

            this._iosSwiperUnderLay.style.zIndex = "1000";
            this._iosSwiperUnderLay.style.opacity = "1";
            this._iosSwiperUnderLay.style.visibility = "";

            this._iosSwiperInterLay.style.zIndex = "1002";
            this._iosSwiperInterLay.style.opacity = "1";
            this._iosSwiperInterLay.style.visibility = "";

            this._iosSwiperOverLay.style.zIndex = "1001";
            this._iosSwiperOverLay.style.opacity = "1";
            this._iosSwiperOverLay.style.visibility = "";

            // this.iframeRemoveIOSTouch();

        } else {

            // disableBodyScroll(document.getElementById("wrapper"));

            this._iosSwiperUnderLay.style.zIndex = "0"; //1000
            this._iosSwiperUnderLay.style.opacity = "0";
            this._iosSwiperUnderLay.style.visibility = "hidden";

            this._iosSwiperInterLay.style.zIndex = "0"; //1002
            this._iosSwiperInterLay.style.opacity = "0";
            this._iosSwiperInterLay.style.visibility = "hidden";

            this._iosSwiperOverLay.style.zIndex = "0"; //1001
            this._iosSwiperOverLay.style.opacity = "0";
            this._iosSwiperOverLay.style.visibility = "hidden";

            // this.iframeAddIOSTouch();
        }
    }
}